import { Box, Input as ChakraInput } from "@chakra-ui/react"
import { HTMLInputTypeAttribute } from "react"
import { RenderPropsArgs } from "src/components/common/authForm"
import FormText from "src/components/common/formText"
import usePageStyling from "src/hooks/usePageStyling"

type Props = {
  title: string
  id: string
  name: string
  type: HTMLInputTypeAttribute
  value: string
  error: string | undefined
  autoComplete?: string
} & Pick<RenderPropsArgs, "handleBlur" | "handleChange">

/**
 * @description Compound component for Authentication Inputs
 */
function Input() {
  return <></>
}

Input.Default = ({
  title,
  id,
  name,
  type,
  value,
  error,
  handleChange,
  handleBlur,
  autoComplete = "off"
}: Props) => {
  const roomStyles = usePageStyling("authPageStyling")

  return (
    <Box flex="1">
      <FormText
        display="flex"
        justifyContent="space-between"
        fontWeight="bold"
        color={roomStyles?.authPagePanelSubTextColor ?? "rgb(74, 85, 104)"}
      >
        {title}
        <FormText
          color={roomStyles?.authPageWarningColor ?? "red"}
          fontSize="12px"
          mt="0"
        >
          {error}
        </FormText>
      </FormText>
      <ChakraInput
        type={type}
        error={error}
        value={value}
        id={id}
        name={name}
        enterKeyHint="send"
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={title}
        mt=".2rem"
        autoComplete={autoComplete}
        background="white"
      />
    </Box>
  )
}

Input.Learnmachine = ({
  title,
  id,
  name,
  type,
  value,
  error,
  handleChange,
  handleBlur,
  autoComplete = "off"
}: Props) => {
  const roomStyles = usePageStyling("authPageStyling")

  return (
    <Box flex="1">
      <FormText display="flex" justifyContent="space-between" fontWeight="bold">
        {title}
        <FormText
          color={roomStyles?.authPageWarningColor ?? "red"}
          fontSize="12px"
          mt="0"
        >
          {error}
        </FormText>
      </FormText>
      <ChakraInput
        type={type}
        error={error}
        value={value}
        name={name}
        id={id}
        enterKeyHint="send"
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder=""
        background="white"
        color="#555"
        height="32px"
        padding="6px 12px"
        mt=".2rem"
        borderRadius="16px"
        fontSize="14px"
        _focus={{}}
        _active={{}}
        autoComplete={autoComplete}
      />
    </Box>
  )
}

export default Input
